export { tr } from '@payloadcms/translations/languages/tr'
